import React from 'react'
import classNames from 'classnames'

export const StagesIndicator = ({
  children,
  className = '',
  state = null,
  ...props
}) => {

  const classes = [
    'inline-flex',
    'items-center'
  ];

  const dotClasses = [
    'h-2',
    'w-2',
    'rounded-full'
  ];

  const childClasses = [
    'ml-2',
    'font-normal',
    'text-sm'
  ];

  dotClasses.push({
    success: 'bg-positive',
    error: 'bg-negative',
    warning: 'bg-warning',
    info: 'bg-primary'
  }[state] || 'bg-primary')

  return (
    <span
      {...props}
      className={classNames(classes, className)}
    >
      <span className={classNames(dotClasses)}></span>
      <span className={classNames(childClasses)}>
        {children}
      </span>
    </span>
  )
}

export default StagesIndicator

